import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { Options } from "ng5-slider";
import { CommonService } from "../Services/common.service";
import { CardServiceService } from "../Services/card-service.service";
import { AuthService } from "../Services/auth.service";
import { CookieService } from '../Services/cookie';

@Component({
  selector: "app-card-request-supplementary",
  templateUrl: "./card-request-supplementary.component.html",
  standalone:false,
  styleUrls: ["./card-request-supplementary.component.scss"],
})
export class CardRequestSupplementaryComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  Acceptlimit: any;

  RelationshipList: any;
  selectedRelationship: string = "";

  constructor(
    private _router: Router,
    private location: Location,
    private common: CommonService,
    private auth: AuthService,
    public cardService: CardServiceService,
    private cookieService: CookieService
  ) {}

  async ngOnInit(): Promise<any> {
    this.RelationshipList = [
      {
        iconClass: "",
        displayValue: "Parent",
      },
      {
        iconClass: "",
        displayValue: "Siblings",
      },
      {
        iconClass: "",
        displayValue: "Spouse",
      },
      {
        iconClass: "",
        displayValue: "Children",
      },
    ];
    let a =await this.cookieService.get("AutoTempLimitObj", false);
    if (a) {
      this.cardService.AutoTempLimitObj = JSON.parse(a);
    }
  }

  back() {
    this.location.back();
  }

  cardLimitPermanent() {
    this._router.navigateByUrl("/CardLimitPermanent");
  }

  cardLimitSuccess() {
    this._router.navigateByUrl("/CardLimitSuccess");
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  AcceptLimit() {
    this.common.presentLoading();
    this.cardService
      .AcceptCardLimit(
        this.cardService.AutoTempLimitObj.limitRequestId,
        this.auth.accessToken
      )
      .then((data: any) => {
        if (data?.response?.code == 1) {
          this.common.hideLoading();
          this.Acceptlimit = data.response.content;
          console.log("this.Acceptlimit", this.Acceptlimit);
          this._router.navigate(["/CardLimitSuccess"], {
            queryParams: { Decline: false },
          });
        } else {
          this.common.hideLoading();
          this.common.ParseErrorAlert("", "OK", this._router, data);
        }
      });
  }

  onRelationshipChange(event) {
    this.selectedRelationship = event.displayValue;
  }
    cardRequestVerifyYourself() {
    this._router.navigateByUrl("/CardRequestVerifyYourself");
  }
}
